import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)<{ backgroundImage: string }>`
  ion-content {
    --background: url(${(props) => props.backgroundImage}) center/cover
      no-repeat;
  }
`;

export const OverlayStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 52.81%,
    rgba(5, 1, 14, 0.84) 70.83%,
    #0a021a 80.49%,
    #2b0e21 100%
  );
`;

export const ContentWrapperStyles = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 48px 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  z-index: 15;
`;
